import styled from 'styled-components'

export const VideoContainer = styled.li`
  list-style-type: none;
  display: flex;
  gap: 20px;

  @media (max-width: 576px){
    flex-direction: column;
    margin-left: 12px;
  }
`

export const VideoImg = styled.img`
  width: 40%;

  @media (max-width: 768px){
    width: 280px;
  }

  @media (max-width: 576px){
    width: 96%;
  }
`

export const VideoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 576px){
    display: none;
  }
`

export const VideoTitle = styled.p`
  color: ${props => props.color};
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0px;

  @media (max-width: 768px){
  font-size: 15px;
  }
`

export const VideoPara = styled.p`
  color: ${props => props.paraColor};
  font-size: 14px;

  @media (max-width: 768px){
  font-size: 13px;
  }
`

export const VideoCardXs = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0px 5px;

  @media (min-width: 576px){
    display: none;
  }
`

export const VideoLogo = styled.img`
  width: 40px;
  height: 40px;
`

export const VideoText = styled.div``
